import React from 'react'
import Layout from '../../Layout'
import First_pane from './First_Pane'
import Interior from '../../Layout/Block/Interior'


const Biote_aqua = () => {
  return (
    <Layout>
      <First_pane />
      <Interior />
    
    </Layout>
  )
}

export default Biote_aqua